import { createSelector } from "reselect";
import { get } from "lodash";

import { getPageContent } from "shared/selectors/base";

// eslint-disable-next-line import/prefer-default-export
export const getReferences = createSelector([getPageContent], pageContent =>
  get(pageContent, "references", [])
);
